module.exports = __webpack_public_path__ + "static/media/c7.6386ab66.png";